const INITIAL_STATE = { registro: {}, modoTela: 'lista', lista: [], listaAnimal: [] };

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'BAIXA_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};
        case 'BAIXA_LISTADO':
            return { ...state, modoTela: 'lista', lista: action.payload.data };
		case 'BAIXA_ANIMAL_SELECT_LISTADO':
            return { ...state, listaAnimal: action.payload.data };
        default:
            return state;
    }
}
